module.exports = __webpack_public_path__ + "static/media/c60.b45a2f0f.png";